import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { shareOwnershipSuccessful, reset, revokeOwnershipSuccessful, getUpdatedOwnershipInfoSuccessful, } from "store/knowledge-base-item/knowledge-base-item.actions";
import { initSuccessful, loadDecisionTree, loadDecisionTreeFailure, loadDecisionTreeSuccessful, setDecisionTreeSelectedSteps, setDecisionTreeCurrentStep, resetDecisionTreeSelectedSteps, loadParametersSuccessful, loadParametersFailure, loadBioreactorsSuccessful, setDecisionTreeModalOpen, setDecisionTreePreviousStep, loadMetricTemplatesSuccessful, setRenamingProgress, setScrollElement, setAppVersions, loadPsTagsSuccessful, loadRsTagsSuccessful, setRsEntityCreatingModalOpen, setOffline, setNoConnectionDialogOpen, setLastRequestedRoute, loadBioreactorParametersSuccessful, loadProcessVariablesSuccessful, loadParameterTypesSuccessful, setDetailsKnowledgeItemToView, changeLocation, } from "./global.actions";
import initialState from "./global.store";
import { prepareBioreactors, prepareResult0DParameters } from "./global.utils";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(initSuccessful, (state) => {
        state.isInited = true;
    })
        .addCase(setOffline, (state, { payload }) => {
        state.isOffline = payload;
    })
        .addCase(changeLocation, (state, { payload }) => {
        state.lastRequestedRoute = payload.location.pathname;
    })
        .addCase(setLastRequestedRoute, (state, { payload }) => {
        state.lastRequestedRoute = payload;
    })
        .addCase(setNoConnectionDialogOpen, (state, { payload }) => {
        state.noConnectionDialogOpen = payload;
    })
        .addCase(loadDecisionTree, (state) => {
        state.decisionTreeLoading = true;
    })
        .addCase(loadDecisionTreeSuccessful, (state, { payload }) => {
        state.decisionTreeLoading = false;
        state.decisionTree = payload;
        state.decisionTreeCurrentStep = payload;
    })
        .addCase(setDecisionTreeCurrentStep, (state, { payload }) => {
        state.decisionTreeCurrentStep = payload;
    })
        .addCase(setDecisionTreePreviousStep, (state, { payload }) => {
        state.decisionTreePreviousStep = payload;
    })
        .addCase(setDecisionTreeModalOpen, (state, { payload }) => {
        state.decisionTreeModalOpened = payload;
    })
        .addCase(setDecisionTreeSelectedSteps, (state, { payload }) => {
        state.decisionTreeSelectedSteps = payload;
    })
        .addCase(resetDecisionTreeSelectedSteps, (state) => {
        state.decisionTreeSelectedSteps = [];
    })
        .addCase(loadDecisionTreeFailure, (state) => {
        state.decisionTreeLoading = false;
    })
        .addCase(setRsEntityCreatingModalOpen, (state, { payload }) => {
        state.rsEntityCreatingModalOpened = payload;
    })
        .addCase(setDetailsKnowledgeItemToView, (state, { payload }) => {
        state.detailsKnowledgeItemToView = payload;
    })
        .addCase(reset, (state) => {
        state.detailsKnowledgeItemToView = undefined;
    })
        .addCase(loadParametersSuccessful, (state, { payload }) => {
        state[payload.type] = prepareResult0DParameters(payload.data).reduce((acc, parameter) => ({ ...acc, [parameter.id]: parameter }), {});
    })
        .addCase(loadMetricTemplatesSuccessful, (state, { payload }) => {
        state.MetricTemplates = payload.reduce((acc, template) => ({ ...acc, [template.id]: template }), {});
    })
        .addCase(loadBioreactorsSuccessful, (state, { payload }) => {
        state.Bioreactors = prepareBioreactors(payload);
    })
        .addCase(loadBioreactorParametersSuccessful, (state, { payload }) => {
        state.bioreactorParameters = payload;
    })
        .addCase(loadProcessVariablesSuccessful, (state, { payload }) => {
        state.processVariables = payload;
    })
        .addCase(loadParameterTypesSuccessful, (state, { payload }) => {
        state.parameterTypes = payload.categories;
    })
        .addCase(loadParametersFailure, (state) => {
        state.isInited = false;
    })
        .addCase(loadPsTagsSuccessful, (state, { payload }) => {
        state.psTags = payload;
    })
        .addCase(loadRsTagsSuccessful, (state, { payload }) => {
        state.rsTags = payload;
    })
        .addCase(setRenamingProgress, (state, { payload }) => {
        state.renamingInProgress = payload;
    })
        .addCase(setScrollElement, (state, { payload: { element, isScroll, boundingBox } }) => {
        state.scrollElements = { ...state.scrollElements, [element]: { isScroll, boundingBox } };
    })
        .addCase(setAppVersions, (state, { payload }) => {
        state.appVersions = payload;
    })
        .addCase(getUpdatedOwnershipInfoSuccessful, (state, { payload }) => {
        const { createdAt, createdBy, lastSavedBy, lastSavedDate, owners } = payload;
        if (state.detailsKnowledgeItemToView) {
            state.detailsKnowledgeItemToView = {
                ...state.detailsKnowledgeItemToView,
                createdAt,
                createdBy,
                lastSavedBy,
                lastSavedDate,
                owners,
            };
        }
    })
        .addMatcher(isAnyOf(shareOwnershipSuccessful, revokeOwnershipSuccessful), (state, { payload }) => {
        state.detailsKnowledgeItemToView = {
            ...state.detailsKnowledgeItemToView,
            ...payload.knowledgeBaseItem,
        };
    });
});
